import React, {Fragment, useState,} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import {getFeatureGroupName} from "../../../../../misc/helpers";
import {getCurrentWizardNavItems, getFeatureGroupFromWizardGroup} from "./lookWizardFunctions";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {updateNavigationCount} from "../../../../../actions/lookFunctions";
import {getAdditionalFeaturesOnScroll} from "../../../../../api/look-api";
import {scrolledVerticalToTheEnd} from "../../../../visComponents/navigation/navUtils";
import LookVirtualizedList from "../lookCategory/lookVirtualizedList";
import NavigationLoader from "../../../ui/navigationLoader";
import GroheVirtualizedList from "../../../grohe/groheNavigation/groheFeatures/groheVirtualizedList";
import {useFeaturesChecker} from "../../../../../misc/helperHooks";
import LookMainCategoryLoading from "../lookCategory/lookMainCategoryLoading";
import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";
import WithClickCount from "../../../hocs/withClickCount";
import LookCanvasContext from "../../../lookCanvasContext";
import {getReorderedItems, getReplacedNavItemsWithUnlockedFeatures} from "../../lookNavigationFunctions";
import LookLockTutorialCaller from "../../../popups/lockedOverlay/lookLockTutorialCaller";


const LookWizardSectionList = (props) => {

  const {wizardGroup, intl, fabricatorData, lookViewType, contentHeight, isMobile, navItems, visualizersLoadedLength} = props;

  const [additionalFeaturesLoading, setAdditionalFeaturesLoading] = useState(false);

  const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
  // console.log("featureGroup", featureGroup);

  const featuresLoaded = useFeaturesChecker(featureGroup, visualizersLoadedLength);

  if (!featureGroup) {
    return null
  }

  if (!featuresLoaded) {
    return <LookMainCategoryLoading featureGroup={featureGroup} contentHeight={contentHeight}/>
  }

  // if (!featureGroup.allFeaturesReceived) {
  //   return <AllFeaturesChecker subPart={{part: featureGroup}} callBack={updateNavigationCount} loaderOnly={true}/>
  // }

  const onScrollHandler = async (scrollObject) => {
    if (featureGroup.getRealFeaturesReceivedProperty() || !scrolledVerticalToTheEnd(scrollObject)) {
      return
    }
    setAdditionalFeaturesLoading(true);
    await getAdditionalFeaturesOnScroll(featureGroup);
    await new Promise(resolve => setTimeout(resolve, 300)); // make sure the loading view is rendered
    // console.log("scrollObject", scrollObject);
    document.querySelector(".ReactVirtualized__Grid").scrollTop = scrollObject.scrollTop - 26;
    setAdditionalFeaturesLoading(false);
  }

  return (
    <Fragment>
      {IS_PRODUCT_JOURNEY ? (
        <div className="grohe-features__title grohe-features__title--wizard">
          <span className="grohe-features__title-text">
            <FormattedMessage id="buttons.select"/> {getFeatureGroupName(featureGroup, intl, fabricatorData)}
          </span>
        </div>
      ) : (
        <h3 className="lw-content__title">
          {wizardGroup.headerTitle || (
            <Fragment>
              <FormattedMessage id="buttons.select"/> {getFeatureGroupName(featureGroup, intl, fabricatorData)}
            </Fragment>
          )}
        </h3>
      )}
      <div className={"lm-features lm-features--type-" + lookViewType}>
        {navItems.length ? (
          <LookCanvasContext.Consumer>
            {(imageCanvas) => (
              <WithClickCount>
                {(maxClickCountReached) => (
                  <WithUpdateLookCartItem>
                    {(updateLookCartItem) => (
                      IS_PRODUCT_JOURNEY
                        ? <GroheVirtualizedList renderList={navItems}
                                                imageCanvas={imageCanvas}
                                                maxClickCountReached={maxClickCountReached}
                                                updateLookCartItem={updateLookCartItem}
                                                isWizard={true}
                                                wizardGroup={wizardGroup}
                                                onScrollHandler={onScrollHandler}/>
                        : (
                          <Fragment>
                            <LookLockTutorialCaller navItems={navItems} wizardGroup={wizardGroup}/>
                            <LookVirtualizedList contentHeight={contentHeight}
                                                 imageCanvas={imageCanvas}
                                                 maxClickCountReached={maxClickCountReached}
                                                 updateLookCartItem={updateLookCartItem}
                                                 renderList={navItems}
                                                 isMobile={isMobile}
                                                 isWizard={true}
                                                 wizardGroup={wizardGroup}
                                                 onScrollHandler={onScrollHandler}
                                                 lookViewType={lookViewType}/>
                          </Fragment>
                        )
                    )}
                  </WithUpdateLookCartItem>
                )}
              </WithClickCount>
            )}
          </LookCanvasContext.Consumer>
        ) : null}
      </div>
      {additionalFeaturesLoading ? <NavigationLoader/> : null}
    </Fragment>
  )
};

LookWizardSectionList.propTypes = {
  wizardGroup: PropTypes.shape(wizardGroupInterface).isRequired,
  wizardStepIndex: PropTypes.number.isRequired,
  contentHeight: PropTypes.number,
}

const mapStateToProps = (store, ownProps) => {
  const {lookViewType, navigationCount, lookActiveFeature, lookActiveFeaturePositionInList} = store.lookState;
  const {wizardSelectedValues, wizardActiveItem, wizardActiveStep} = store.wizardState;
  const {filterGroups, selectedFilters} = store.filterState;
  const {groheFiltersSearchText} = store.groheState;
  const {isMobile, visualizersLoaded} = store.serverState;
  const {shopPageOpened} = store.shopState;

  const {wizardGroup, wizardStepIndex} = ownProps;
  const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
  // console.log("featureGroup", featureGroup);

  let navItems = (wizardActiveStep === wizardStepIndex)
    ? getCurrentWizardNavItems(wizardSelectedValues, wizardStepIndex, wizardActiveItem, wizardGroup, featureGroup,
      filterGroups, groheFiltersSearchText, selectedFilters, shopPageOpened, true)
    : [];

  navItems = getReplacedNavItemsWithUnlockedFeatures(navItems, filterGroups);
  const activePositionInListExist = typeof lookActiveFeaturePositionInList === "number";
  // navItems = getReorderedItems(navItems, featureGroup.activeFeature, featureGroup.partId, featureGroup, true, !wizardSelectedValues[wizardActiveStep]);
  navItems = featureGroup
    ? getReorderedItems(navItems,  featureGroup.activeFeature, featureGroup.partId, featureGroup, true, false, lookViewType)
    : getReorderedItems(navItems,  null, "", null, true, false, lookViewType)
  if (activePositionInListExist && lookActiveFeature) {  // swap places with clicked position (is used only for cases when 1) option click 2) navigation item click)
    const currentPositionInList = navItems.findIndex(navItem => navItem.part.dbFeature.sharedFeatureName === lookActiveFeature.dbFeature.sharedFeatureName);
    if (currentPositionInList >= 0 && currentPositionInList !== lookActiveFeaturePositionInList) {
      [navItems[currentPositionInList], navItems[lookActiveFeaturePositionInList]] = [navItems[lookActiveFeaturePositionInList], navItems[currentPositionInList]]
    }
  }

  return {
    fabricatorData: store.fabricatorState,
    lookViewType,
    // wizardSelectedValues,
    // wizardActiveItem,
    // filterGroups,
    navigationCount,
    isMobile,
    // wizardActiveStep,
    navItems,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

const mapDispatchToProps = {
  updateNavigationCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardSectionList)
)
